import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-771d1e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial-actions tutorial-mode" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下方保留文字教程，可按组查看。", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tutorial-intro" }, "按顺序认识管理端，也可以选择一个分组查看。目录随当前账号可见功能自动更新。", -1))
const _hoisted_4 = { class: "tutorial-actions" }
const _hoisted_5 = { class: "tutorial-body" }
const _hoisted_6 = { "aria-label": "教程目录" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "tutorial-actions" }
const _hoisted_12 = { class: "tutorial-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_SubfunctionTour = _resolveComponent("SubfunctionTour")!
  const _component_AdminStepTour = _resolveComponent("AdminStepTour")!

  return (_ctx.adminTutorialPolicy.ready && _ctx.adminTutorialPolicy.enabled)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("button", {
          class: "tutorial-trigger",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startCurrentPage && _ctx.startCurrentPage(...args)))
        }, "引导教程"),
        _createVNode(_component_a_modal, {
          visible: _ctx.visible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
          title: "管理端引导教程",
          width: 960,
          footer: null,
          onCancel: _ctx.dismiss
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startSteps(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("认识管理端 · 分步引导")
                ]),
                _: 1
              }),
              (_ctx.canTourCustomers)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startSteps(true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("客户管理 · 分步引导")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_2
            ]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                type: _ctx.selectedGroup === '' ? 'primary' : 'default',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectGroup('')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全部教程")
                ]),
                _: 1
              }, 8, ["type"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                return (_openBlock(), _createBlock(_component_a_button, {
                  key: group,
                  type: _ctx.selectedGroup === group ? 'primary' : 'default',
                  onClick: ($event: any) => (_ctx.selectGroup(group))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(group), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              }), 128))
            ]),
            _createElementVNode("p", null, "已查看 " + _toDisplayString(_ctx.completedCount) + " / " + _toDisplayString(_ctx.catalog.length) + " 项 · 查看记录保存在当前浏览器", 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("nav", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: item.path,
                    class: _normalizeClass({active:_ctx.current?.path === item.path}),
                    onClick: ($event: any) => (_ctx.activePath = item.path)
                  }, [
                    _createElementVNode("small", null, _toDisplayString(item.group), 1),
                    _createElementVNode("span", null, _toDisplayString(item.title), 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.completed.includes(item.path) ? '已查看' : '未查看'), 1)
                  ], 10, _hoisted_7))
                }), 128))
              ]),
              (_ctx.current)
                ? (_openBlock(), _createElementBlock("article", _hoisted_8, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.current.title), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                      return (_openBlock(), _createElementBlock("section", {
                        key: section.title
                      }, [
                        _createElementVNode("h3", null, _toDisplayString(section.title), 1),
                        (section.content)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(section.content), 1))
                          : _createCommentVNode("", true),
                        (section.steps)
                          ? (_openBlock(), _createElementBlock("ol", _hoisted_10, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.steps, (step) => {
                                return (_openBlock(), _createElementBlock("li", { key: step }, _toDisplayString(step), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_button, {
                        disabled: _ctx.index <= 0,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.move(-1)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("上一项")
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.acknowledge
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.index < _ctx.filtered.length - 1 ? '已了解，下一项' : '已了解，完成本组'), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      (_ctx.current.path !== '#overview')
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _ctx.visit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("进入此功能")
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_button, { onClick: _ctx.dismiss }, {
                default: _withCtx(() => [
                  _createTextVNode("关闭，稍后可再次打开")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "onCancel"]),
        _createVNode(_component_SubfunctionTour),
        _createVNode(_component_AdminStepTour, {
          active: _ctx.tourActive,
          steps: _ctx.tourSteps,
          label: _ctx.tourLabel,
          onFinish: _ctx.finishTour,
          onCatalog: _ctx.showCatalog
        }, null, 8, ["active", "steps", "label", "onFinish", "onCatalog"])
      ], 64))
    : _createCommentVNode("", true)
}